/**
 * Do not edit directly
 * Generated on Thu, 05 Mar 2026 15:05:46 GMT
 */

module.exports = {
  "czr-palace-dark": {
    "fg": {
      "default": {
        "default": {
          "value": "#f6f2ed",
          "type": "color",
          "description": "Default color for text, icons and borders.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.gray-dark.1200}",
            "type": "color",
            "description": "Default color for text, icons and borders.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-default",
          "path": [
            "czr-palace-dark",
            "fg",
            "default",
            "default"
          ]
        },
        "moderate": {
          "value": "#aeaaa6",
          "type": "color",
          "description": "Content that is secondary or that provides additional context.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.gray-dark.900}",
            "type": "color",
            "description": "Content that is secondary or that provides additional context.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-moderate",
          "path": [
            "czr-palace-dark",
            "fg",
            "default",
            "moderate"
          ]
        },
        "subtle": {
          "value": "#686663",
          "type": "color",
          "description": "Dividers or other elements not critical to understanding the flow of an interface.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.gray-dark.700}",
            "type": "color",
            "description": "Dividers or other elements not critical to understanding the flow of an interface.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-subtle",
          "path": [
            "czr-palace-dark",
            "fg",
            "default",
            "subtle"
          ]
        },
        "minimal": {
          "value": "#383736",
          "type": "color",
          "description": "Dividers or other elements not critical to understanding the flow of an interface.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.gray-dark.600}",
            "type": "color",
            "description": "Dividers or other elements not critical to understanding the flow of an interface.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-minimal",
          "path": [
            "czr-palace-dark",
            "fg",
            "default",
            "minimal"
          ]
        },
        "inverse": {
          "default": {
            "value": "#030303",
            "type": "color",
            "description": "Use on bg.primary.",
            "attributes": {
              "category": "color"
            },
            "filePath": "tokens/tokens.json",
            "isSource": true,
            "original": {
              "value": "{core.silver-dark.100}",
              "type": "color",
              "description": "Use on bg.primary.",
              "attributes": {
                "category": "color"
              }
            },
            "name": "fg-inverse",
            "path": [
              "czr-palace-dark",
              "fg",
              "default",
              "inverse",
              "default"
            ]
          }
        }
      },
      "primary": {
        "default": {
          "value": "#F59337",
          "type": "color",
          "description": "The most important elements in the interface in which a user must take action on.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.pumpkin-dark.900}",
            "type": "color",
            "description": "The most important elements in the interface in which a user must take action on.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-primary",
          "path": [
            "czr-palace-dark",
            "fg",
            "primary",
            "default"
          ]
        },
        "strong": {
          "value": "#FFB77C",
          "type": "color",
          "description": "Selected text, icons and borders.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.pumpkin-dark.1000}",
            "type": "color",
            "description": "Selected text, icons and borders.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-primary-strong",
          "path": [
            "czr-palace-dark",
            "fg",
            "primary",
            "strong"
          ]
        },
        "minimal": {
          "value": "#22170D",
          "type": "color",
          "description": "For content that is secondary or that provides additional context. Does not pass contrast standards.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.pumpkin-dark.300}",
            "type": "color",
            "description": "For content that is secondary or that provides additional context. Does not pass contrast standards.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-primary-minimal",
          "path": [
            "czr-palace-dark",
            "fg",
            "primary",
            "minimal"
          ]
        }
      },
      "global-black": {
        "value": "#000000",
        "type": "color",
        "description": "When UI element will always be black regardless of theme.",
        "attributes": {
          "category": "color"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.neutrals.black}",
          "type": "color",
          "description": "When UI element will always be black regardless of theme.",
          "attributes": {
            "category": "color"
          }
        },
        "name": "fg-global-black",
        "path": [
          "czr-palace-dark",
          "fg",
          "global-black"
        ]
      },
      "global-white": {
        "value": "#ffffff",
        "type": "color",
        "description": "When UI element will always be white regardless of theme.",
        "attributes": {
          "category": "color"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.neutrals.white}",
          "type": "color",
          "description": "When UI element will always be white regardless of theme.",
          "attributes": {
            "category": "color"
          }
        },
        "name": "fg-global-white",
        "path": [
          "czr-palace-dark",
          "fg",
          "global-white"
        ]
      },
      "focus": {
        "default": {
          "value": "#259CFF",
          "type": "color",
          "description": "The color used to indicate focus on an interactive element, such as a button or input field.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.800}",
            "type": "color",
            "description": "The color used to indicate focus on an interactive element, such as a button or input field.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-focus",
          "path": [
            "czr-palace-dark",
            "fg",
            "focus",
            "default"
          ]
        },
        "inverse": {
          "value": "#1B3665",
          "type": "color",
          "description": "The inverse color of the focus color, used to indicate focus on elements with a dark background. This color should provide enough contrast with the dark background to be easily visible.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.500}",
            "type": "color",
            "description": "The inverse color of the focus color, used to indicate focus on elements with a dark background. This color should provide enough contrast with the dark background to be easily visible.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-focus-inverse",
          "path": [
            "czr-palace-dark",
            "fg",
            "focus",
            "inverse"
          ]
        }
      },
      "text-link": {
        "default": {
          "value": "#348FB2",
          "type": "color",
          "description": "For hyperlinks. This passes contrast standards on the background and surrounding text.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.aqua-dark.700}",
            "type": "color",
            "description": "For hyperlinks. This passes contrast standards on the background and surrounding text.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "fg-text-link",
          "path": [
            "czr-palace-dark",
            "fg",
            "text-link",
            "default"
          ]
        }
      }
    },
    "bg": {
      "default": {
        "base": {
          "value": "#030407",
          "type": "color",
          "description": "Provides visual rest and contrast against the default background.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.100}",
            "type": "color",
            "description": "Provides visual rest and contrast against the default background.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-base",
          "path": [
            "czr-palace-dark",
            "bg",
            "default",
            "base"
          ]
        },
        "default": {
          "value": "#030407",
          "type": "color",
          "description": "Default background color.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.100}",
            "type": "color",
            "description": "Default background color.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-default",
          "path": [
            "czr-palace-dark",
            "bg",
            "default",
            "default"
          ]
        },
        "layer-one": {
          "value": "#0E101A",
          "type": "color",
          "description": "For elements that lay on top of bg.default and lower layers.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.200}",
            "type": "color",
            "description": "For elements that lay on top of bg.default and lower layers.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-layer-one",
          "path": [
            "czr-palace-dark",
            "bg",
            "default",
            "layer-one"
          ]
        },
        "layer-two": {
          "value": "#131828",
          "type": "color",
          "description": "For elements that lay on top of bg.default and lower layers.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.300}",
            "type": "color",
            "description": "For elements that lay on top of bg.default and lower layers.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-layer-two",
          "path": [
            "czr-palace-dark",
            "bg",
            "default",
            "layer-two"
          ]
        },
        "layer-three": {
          "value": "#19294C",
          "type": "color",
          "description": "For elements that are highlighted on lower bg layers. Check contrast when using.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.400}",
            "type": "color",
            "description": "For elements that are highlighted on lower bg layers. Check contrast when using.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-layer-three",
          "path": [
            "czr-palace-dark",
            "bg",
            "default",
            "layer-three"
          ]
        }
      },
      "primary": {
        "default": {
          "value": "#F59337",
          "type": "color",
          "description": "The most important elements in the interface in which a user must take action on.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.pumpkin-dark.900}",
            "type": "color",
            "description": "The most important elements in the interface in which a user must take action on.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-primary",
          "path": [
            "czr-palace-dark",
            "bg",
            "primary",
            "default"
          ]
        },
        "strong": {
          "value": "#F59337",
          "type": "color",
          "description": "A focal point of content.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.pumpkin-dark.900}",
            "type": "color",
            "description": "A focal point of content.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-primary-strong",
          "path": [
            "czr-palace-dark",
            "bg",
            "primary",
            "strong"
          ]
        },
        "minimal": {
          "value": "#3A2615",
          "type": "color",
          "description": "Content that is secondary or that provides additional context. Needs a border to pass contrast standards.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.pumpkin-dark.400}",
            "type": "color",
            "description": "Content that is secondary or that provides additional context. Needs a border to pass contrast standards.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-primary-minimal",
          "path": [
            "czr-palace-dark",
            "bg",
            "primary",
            "minimal"
          ]
        }
      },
      "transparent": {
        "default": {
          "value": "rgba(0,0,0,0.7)",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.neutrals.opacity.dark.70}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "bg-transparent",
          "path": [
            "czr-palace-dark",
            "bg",
            "transparent",
            "default"
          ]
        }
      }
    },
    "highlight": {
      "accent": {
        "default": {
          "value": "#9963FF",
          "type": "color",
          "description": "Indicate changing elements like live scores.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.ultramarine-dark.700}",
            "type": "color",
            "description": "Indicate changing elements like live scores.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-accent",
          "path": [
            "czr-palace-dark",
            "highlight",
            "accent",
            "default"
          ]
        },
        "strong": {
          "value": "#6F35FF",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.ultramarine-dark.600}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-accent-strong",
          "path": [
            "czr-palace-dark",
            "highlight",
            "accent",
            "strong"
          ]
        },
        "subtle": {
          "value": "#311869",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.ultramarine-dark.400}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-accent-subtle",
          "path": [
            "czr-palace-dark",
            "highlight",
            "accent",
            "subtle"
          ]
        },
        "minimal": {
          "value": "#1F1238",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.ultramarine-dark.300}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-accent-minimal",
          "path": [
            "czr-palace-dark",
            "highlight",
            "accent",
            "minimal"
          ]
        }
      },
      "brand": {
        "default": {
          "value": "#f6f2ed",
          "type": "color",
          "description": "Indicate elements that have a brand flair.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.gray-dark.1200}",
            "type": "color",
            "description": "Indicate elements that have a brand flair.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-brand",
          "path": [
            "czr-palace-dark",
            "highlight",
            "brand",
            "default"
          ]
        },
        "one": {
          "value": "#F51C21",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.brand.palace-red}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-brand-one",
          "path": [
            "czr-palace-dark",
            "highlight",
            "brand",
            "one"
          ]
        }
      },
      "one": {
        "default": {
          "value": "#FFE900",
          "type": "color",
          "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.yellow-dark.1100}",
            "type": "color",
            "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-one",
          "path": [
            "czr-palace-dark",
            "highlight",
            "one",
            "default"
          ]
        }
      },
      "two": {
        "default": {
          "value": "#3CFF00",
          "type": "color",
          "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.lime-dark.1000}",
            "type": "color",
            "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-two",
          "path": [
            "czr-palace-dark",
            "highlight",
            "two",
            "default"
          ]
        }
      },
      "three": {
        "default": {
          "value": "#20F2FF",
          "type": "color",
          "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.cyan-dark.1000}",
            "type": "color",
            "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-three",
          "path": [
            "czr-palace-dark",
            "highlight",
            "three",
            "default"
          ]
        }
      },
      "four": {
        "default": {
          "value": "#E143AE",
          "type": "color",
          "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.pink-dark.700}",
            "type": "color",
            "description": "Highlight a non-important UI element. May not pass contrast standards for foreground.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-four",
          "path": [
            "czr-palace-dark",
            "highlight",
            "four",
            "default"
          ]
        }
      },
      "five": {
        "default": {
          "value": "#FF3465",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.coral-dark.700}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "highlight-five",
          "path": [
            "czr-palace-dark",
            "highlight",
            "five",
            "default"
          ]
        }
      }
    },
    "status": {
      "positive": {
        "default": {
          "value": "#00ac5f",
          "type": "color",
          "description": "A positive message, like a placing or winning a bet.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.green-dark.800}",
            "type": "color",
            "description": "A positive message, like a placing or winning a bet.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-positive",
          "path": [
            "czr-palace-dark",
            "status",
            "positive",
            "default"
          ]
        },
        "strong": {
          "value": "#00C46E",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.green-dark.900}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-positive-strong",
          "path": [
            "czr-palace-dark",
            "status",
            "positive",
            "strong"
          ]
        },
        "subtle": {
          "value": "#007642",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.green-dark.600}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-positive-subtle",
          "path": [
            "czr-palace-dark",
            "status",
            "positive",
            "subtle"
          ]
        },
        "minimal": {
          "value": "#0A140D",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.green-dark.200}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-positive-minimal",
          "path": [
            "czr-palace-dark",
            "status",
            "positive",
            "minimal"
          ]
        }
      },
      "negative": {
        "default": {
          "value": "#FF3465",
          "type": "color",
          "description": "A negative message, like an error, blocking status or a loss of a bet.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.coral-dark.700}",
            "type": "color",
            "description": "A negative message, like an error, blocking status or a loss of a bet.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-negative",
          "path": [
            "czr-palace-dark",
            "status",
            "negative",
            "default"
          ]
        },
        "strong": {
          "value": "#ff5e72",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.coral-dark.800}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-negative-strong",
          "path": [
            "czr-palace-dark",
            "status",
            "negative",
            "strong"
          ]
        },
        "subtle": {
          "value": "#C81844",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.coral-dark.600}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-negative-subtle",
          "path": [
            "czr-palace-dark",
            "status",
            "negative",
            "subtle"
          ]
        },
        "minimal": {
          "value": "#1F0D0D",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.coral-dark.200}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-negative-minimal",
          "path": [
            "czr-palace-dark",
            "status",
            "negative",
            "minimal"
          ]
        }
      },
      "alert": {
        "default": {
          "value": "#9ACEDC",
          "type": "color",
          "description": "A standard alert message, indicating a noteworthy event or condition that requires user attention, such as important updates or reminders.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.turquoise-dark.1000}",
            "type": "color",
            "description": "A standard alert message, indicating a noteworthy event or condition that requires user attention, such as important updates or reminders.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-alert",
          "path": [
            "czr-palace-dark",
            "status",
            "alert",
            "default"
          ]
        },
        "strong": {
          "value": "#D8EBF1",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.turquoise-dark.1100}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-alert-strong",
          "path": [
            "czr-palace-dark",
            "status",
            "alert",
            "strong"
          ]
        },
        "subtle": {
          "value": "#007084",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.turquoise-dark.600}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-alert-subtle",
          "path": [
            "czr-palace-dark",
            "status",
            "alert",
            "subtle"
          ]
        },
        "minimal": {
          "value": "#0A1315",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.turquoise-dark.200}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-alert-minimal",
          "path": [
            "czr-palace-dark",
            "status",
            "alert",
            "minimal"
          ]
        }
      },
      "notification": {
        "value": "#FF3465",
        "type": "color",
        "description": "Use when communicating a non-critical notification in the application interface.",
        "attributes": {
          "category": "color"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.coral-dark.700}",
          "type": "color",
          "description": "Use when communicating a non-critical notification in the application interface.",
          "attributes": {
            "category": "color"
          }
        },
        "name": "status-notification",
        "path": [
          "czr-palace-dark",
          "status",
          "notification"
        ]
      },
      "informational": {
        "default": {
          "value": "#259CFF",
          "type": "color",
          "description": "A standard informational message, providing additional context or guidance without implying any positive or negative sentiment.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.800}",
            "type": "color",
            "description": "A standard informational message, providing additional context or guidance without implying any positive or negative sentiment.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-informational",
          "path": [
            "czr-palace-dark",
            "status",
            "informational",
            "default"
          ]
        },
        "strong": {
          "value": "#63AFFF",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.900}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-informational-strong",
          "path": [
            "czr-palace-dark",
            "status",
            "informational",
            "strong"
          ]
        },
        "subtle": {
          "value": "#19294C",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.400}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-informational-subtle",
          "path": [
            "czr-palace-dark",
            "status",
            "informational",
            "subtle"
          ]
        },
        "minimal": {
          "value": "#0E101A",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.blue-dark.200}",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "status-informational-minimal",
          "path": [
            "czr-palace-dark",
            "status",
            "informational",
            "minimal"
          ]
        }
      }
    },
    "rewards": {
      "background": {
        "default": {
          "value": "#D65E5E",
          "type": "color",
          "description": "When Caesars Rewards requires a call to action or reference.",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "{core.maroon-dark.700}",
            "type": "color",
            "description": "When Caesars Rewards requires a call to action or reference.",
            "attributes": {
              "category": "color"
            }
          },
          "name": "rewards-background",
          "path": [
            "czr-palace-dark",
            "rewards",
            "background",
            "default"
          ]
        }
      }
    },
    "gradient": {
      "brand": {
        "default": {
          "value": "linear-gradient(121deg, #FF7E5E 8.36%, #D65DFE 29.65%, #A39A3C 52.36%, #8BD25F 67.26%, #2BBFCA 79.32%);",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "linear-gradient(121deg, #FF7E5E 8.36%, #D65DFE 29.65%, #A39A3C 52.36%, #8BD25F 67.26%, #2BBFCA 79.32%);",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "gradient-brand",
          "path": [
            "czr-palace-dark",
            "gradient",
            "brand",
            "default"
          ]
        }
      },
      "accent": {
        "default": {
          "value": "radial-gradient(177.26% 274.65% at 38.41% -173.94%, #311869 0%, #141414 100%)",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "radial-gradient(177.26% 274.65% at 38.41% -173.94%, #311869 0%, #141414 100%)",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "gradient-accent",
          "path": [
            "czr-palace-dark",
            "gradient",
            "accent",
            "default"
          ]
        }
      },
      "highlight": {
        "one": {
          "value": "linear-gradient(121deg, #EAFB00 7.3%, #FCCA33 26.46%, #B3AA4F 56.97%, #FCE700 79.32%)",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "linear-gradient(121deg, #EAFB00 7.3%, #FCCA33 26.46%, #B3AA4F 56.97%, #FCE700 79.32%)",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "gradient-highlight-one",
          "path": [
            "czr-palace-dark",
            "gradient",
            "highlight",
            "one"
          ]
        },
        "two": {
          "value": "linear-gradient(180deg, #3CFF00 0%, #249900 31.73%, #3CFF00 63.94%, #249900 94.23%)",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "linear-gradient(180deg, #3CFF00 0%, #249900 31.73%, #3CFF00 63.94%, #249900 94.23%)",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "gradient-highlight-two",
          "path": [
            "czr-palace-dark",
            "gradient",
            "highlight",
            "two"
          ]
        },
        "three": {
          "value": "linear-gradient(180deg, #FF8512 0%, #D17824 39.42%, #FF8512 70.19%, #D17824 92.31%)",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "linear-gradient(180deg, #FF8512 0%, #D17824 39.42%, #FF8512 70.19%, #D17824 92.31%)",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "gradient-highlight-three",
          "path": [
            "czr-palace-dark",
            "gradient",
            "highlight",
            "three"
          ]
        },
        "four": {
          "value": "linear-gradient(180deg, #56107F 0%, #3D488C 100%)",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "linear-gradient(180deg, #56107F 0%, #3D488C 100%)",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "gradient-highlight-four",
          "path": [
            "czr-palace-dark",
            "gradient",
            "highlight",
            "four"
          ]
        },
        "five": {
          "value": "linear-gradient(180deg, #3D488C 0%, #56107F 100%)",
          "type": "color",
          "attributes": {
            "category": "color"
          },
          "filePath": "tokens/tokens.json",
          "isSource": true,
          "original": {
            "value": "linear-gradient(180deg, #3D488C 0%, #56107F 100%)",
            "type": "color",
            "attributes": {
              "category": "color"
            }
          },
          "name": "gradient-highlight-five",
          "path": [
            "czr-palace-dark",
            "gradient",
            "highlight",
            "five"
          ]
        }
      }
    },
    "spacing": {
      "2xs": {
        "value": "0.25rem",
        "type": "spacing",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.spacing.1}",
          "type": "spacing",
          "attributes": {
            "category": "size"
          }
        },
        "name": "spacing-2xs",
        "path": [
          "czr-palace-dark",
          "spacing",
          "2xs"
        ]
      },
      "xs": {
        "value": "0.50rem",
        "type": "spacing",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.spacing.2}",
          "type": "spacing",
          "attributes": {
            "category": "size"
          }
        },
        "name": "spacing-xs",
        "path": [
          "czr-palace-dark",
          "spacing",
          "xs"
        ]
      },
      "sm": {
        "value": "0.75rem",
        "type": "spacing",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.spacing.3}",
          "type": "spacing",
          "attributes": {
            "category": "size"
          }
        },
        "name": "spacing-sm",
        "path": [
          "czr-palace-dark",
          "spacing",
          "sm"
        ]
      },
      "md": {
        "value": "1rem",
        "type": "spacing",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.spacing.4}",
          "type": "spacing",
          "attributes": {
            "category": "size"
          }
        },
        "name": "spacing-md",
        "path": [
          "czr-palace-dark",
          "spacing",
          "md"
        ]
      },
      "lg": {
        "value": "1.5rem",
        "type": "spacing",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.spacing.6}",
          "type": "spacing",
          "attributes": {
            "category": "size"
          }
        },
        "name": "spacing-lg",
        "path": [
          "czr-palace-dark",
          "spacing",
          "lg"
        ]
      },
      "xl": {
        "value": "2rem",
        "type": "spacing",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.spacing.8}",
          "type": "spacing",
          "attributes": {
            "category": "size"
          }
        },
        "name": "spacing-xl",
        "path": [
          "czr-palace-dark",
          "spacing",
          "xl"
        ]
      },
      "2xl": {
        "value": "4rem",
        "type": "spacing",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.spacing.16}",
          "type": "spacing",
          "attributes": {
            "category": "size"
          }
        },
        "name": "spacing-2xl",
        "path": [
          "czr-palace-dark",
          "spacing",
          "2xl"
        ]
      }
    },
    "box-shadow": {
      "2xs": {
        "value": [
          {
            "x": "0",
            "y": "0.063rem",
            "blur": "0.063rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.02)",
            "type": "dropShadow"
          },
          {
            "x": "0",
            "y": "0.063rem",
            "blur": "0.125rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.03)",
            "type": "dropShadow"
          }
        ],
        "type": "boxShadow",
        "attributes": {
          "category": "boxShadow"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.box-shadow.1}",
          "type": "boxShadow",
          "attributes": {
            "category": "boxShadow"
          }
        },
        "name": "box-shadow-2xs",
        "path": [
          "czr-palace-dark",
          "box-shadow",
          "2xs"
        ]
      },
      "xs": {
        "value": [
          {
            "x": "0",
            "y": "0.063rem",
            "blur": "0.125rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.03)",
            "type": "dropShadow"
          },
          {
            "x": "0",
            "y": "0.125rem",
            "blur": "0.25rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.04)",
            "type": "dropShadow"
          }
        ],
        "type": "boxShadow",
        "attributes": {
          "category": "boxShadow"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.box-shadow.3}",
          "type": "boxShadow",
          "attributes": {
            "category": "boxShadow"
          }
        },
        "name": "box-shadow-xs",
        "path": [
          "czr-palace-dark",
          "box-shadow",
          "xs"
        ]
      },
      "sm": {
        "value": [
          {
            "x": "0",
            "y": "0.125rem",
            "blur": "0.25rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.04)",
            "type": "dropShadow"
          },
          {
            "x": "0",
            "y": "0.25rem",
            "blur": "0.5rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.05)",
            "type": "dropShadow"
          }
        ],
        "type": "boxShadow",
        "attributes": {
          "category": "boxShadow"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.box-shadow.6}",
          "type": "boxShadow",
          "attributes": {
            "category": "boxShadow"
          }
        },
        "name": "box-shadow-sm",
        "path": [
          "czr-palace-dark",
          "box-shadow",
          "sm"
        ]
      },
      "md": {
        "value": [
          {
            "x": "0",
            "y": "0.25rem",
            "blur": "0.375rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.05)",
            "type": "dropShadow"
          },
          {
            "x": "0",
            "y": "0.5rem",
            "blur": "0.75rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.06)",
            "type": "dropShadow"
          }
        ],
        "type": "boxShadow",
        "attributes": {
          "category": "boxShadow"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.box-shadow.10}",
          "type": "boxShadow",
          "attributes": {
            "category": "boxShadow"
          }
        },
        "name": "box-shadow-md",
        "path": [
          "czr-palace-dark",
          "box-shadow",
          "md"
        ]
      },
      "lg": {
        "value": [
          {
            "x": "0",
            "y": "0.375rem",
            "blur": "0.625rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.06)",
            "type": "dropShadow"
          },
          {
            "x": "0",
            "y": "0.75rem",
            "blur": "1rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.07)",
            "type": "dropShadow"
          }
        ],
        "type": "boxShadow",
        "attributes": {
          "category": "boxShadow"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.box-shadow.14}",
          "type": "boxShadow",
          "attributes": {
            "category": "boxShadow"
          }
        },
        "name": "box-shadow-lg",
        "path": [
          "czr-palace-dark",
          "box-shadow",
          "lg"
        ]
      },
      "xl": {
        "value": [
          {
            "x": "0",
            "y": "0.5rem",
            "blur": "0.875rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.07)",
            "type": "dropShadow"
          },
          {
            "x": "0",
            "y": "0.875rem",
            "blur": "1.25rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.08)",
            "type": "dropShadow"
          }
        ],
        "type": "boxShadow",
        "attributes": {
          "category": "boxShadow"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.box-shadow.18}",
          "type": "boxShadow",
          "attributes": {
            "category": "boxShadow"
          }
        },
        "name": "box-shadow-xl",
        "path": [
          "czr-palace-dark",
          "box-shadow",
          "xl"
        ]
      },
      "2xl": {
        "value": [
          {
            "x": "0",
            "y": "0.625rem",
            "blur": "1.25rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.08)",
            "type": "dropShadow"
          },
          {
            "x": "0",
            "y": "1.25rem",
            "blur": "2rem",
            "spread": "0",
            "color": "rgba(0,0,0,0.10)",
            "type": "dropShadow"
          }
        ],
        "type": "boxShadow",
        "attributes": {
          "category": "boxShadow"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.box-shadow.24}",
          "type": "boxShadow",
          "attributes": {
            "category": "boxShadow"
          }
        },
        "name": "box-shadow-2xl",
        "path": [
          "czr-palace-dark",
          "box-shadow",
          "2xl"
        ]
      }
    },
    "border-radius": {
      "sm": {
        "value": "0.25rem",
        "type": "borderRadius",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.border-radius.1}",
          "type": "borderRadius",
          "attributes": {
            "category": "size"
          }
        },
        "name": "border-radius-sm",
        "path": [
          "czr-palace-dark",
          "border-radius",
          "sm"
        ]
      },
      "md": {
        "value": "0.5rem",
        "type": "borderRadius",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.border-radius.2}",
          "type": "borderRadius",
          "attributes": {
            "category": "size"
          }
        },
        "name": "border-radius-md",
        "path": [
          "czr-palace-dark",
          "border-radius",
          "md"
        ]
      },
      "lg": {
        "value": "1rem",
        "type": "borderRadius",
        "attributes": {
          "category": "size"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.border-radius.4}",
          "type": "borderRadius",
          "attributes": {
            "category": "size"
          }
        },
        "name": "border-radius-lg",
        "path": [
          "czr-palace-dark",
          "border-radius",
          "lg"
        ]
      }
    },
    "font-family": {
      "primary": {
        "value": "Roboto Flex, Roboto Condensed",
        "type": "fontFamilies",
        "attributes": {
          "category": "content"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.font-family.roboto-flex}, {core.font-family.roboto-condensed}",
          "type": "fontFamilies",
          "attributes": {
            "category": "content"
          }
        },
        "name": "font-family-primary",
        "path": [
          "czr-palace-dark",
          "font-family",
          "primary"
        ]
      },
      "secondary": {
        "value": "Roboto Condensed",
        "type": "fontFamilies",
        "attributes": {
          "category": "content"
        },
        "filePath": "tokens/tokens.json",
        "isSource": true,
        "original": {
          "value": "{core.font-family.roboto-condensed}",
          "type": "fontFamilies",
          "attributes": {
            "category": "content"
          }
        },
        "name": "font-family-secondary",
        "path": [
          "czr-palace-dark",
          "font-family",
          "secondary"
        ]
      }
    }
  }
};
